<template>
  <div class="wrapper">
    <div class="login">
      <h1 class="text-ruderclub-orange">Login</h1>
      <form @submit.prevent="loginUser">
        <div class="mb-4 input-group">
          <input
            type="email"
            id="email"
            v-model="email"
            class="form-control"
            required
          />
          <span class="input-group-text">
            <span class="material-symbols-outlined"> mail </span>
          </span>
        </div>
        <div class="mb-4 input-group">
          <input
            type="password"
            id="password"
            v-model="password"
            class="form-control"
            required
          />
          <span class="input-group-text">
            <span class="material-symbols-outlined"> key </span>
          </span>
        </div>
        <div class="d-flex justify-content-between">
          <router-link to="/" class="btn btn-secondary">Abbrechen</router-link>
          <button type="submit" class="d-flex btn btn-outline-ruderclub-orange">
            <span class="material-symbols-outlined me-2">login</span>
            Login
          </button>
        </div>
      </form>
      <p v-if="errorMessage" class="text-danger mt-3">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import { signInWithEmailAndPassword } from "firebase/auth";
import { firebaseAuth } from "@/main";

export default {
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
    };
  },
  methods: {
    async loginUser() {
      try {
        await signInWithEmailAndPassword(
          firebaseAuth,
          this.email,
          this.password
        );
        this.$router.push("/dashboard");
      } catch (error) {
        console.error(error);
        this.errorMessage = "Login fehlgeschlagen";
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  color: white;
  background-color: var(--ruderclub-dark-green) !important;
}
.login {
  margin: 50px auto;
}
</style>
